import React from "react";
import StandingsTable from "../core/StandingsTable";
import Bracket from "./PlayoffBracket";
import DivisionWinner from "./DivisionWinner";
import { useQuery } from "@tanstack/react-query";
import Loading from "../core/Loading";
// import GamePlayerSpotlight from "../game/GamePlayerSpotlight";
import GameEvent from "../game/GameEvent";
import DivisionInfo from "./DivisionInfo";

// const renderPlayerSpotlight = (playerData) => {
//   if (playerData !== undefined) {
//     return (
//         <GamePlayerSpotlight
//             id={playerData.id}
//             club={playerData.club}
//             title={playerData.title}
//             name={playerData.name}
//             team_name={playerData.team_name}
//             backup={playerData.team_img}
//             desc={playerData.description}
//             stat={playerData.value}
//         />
//     );
//   }
//   return null;
// };

const DivisionTournament = ({ divisionData }) => {

  const processData = (jsonData) => {
    let processedData = {
      groups: [],
      title: jsonData.blip,
      next_game: jsonData.next_game,
      playoffs: jsonData.playoffs,
      champions: jsonData.champions
    };

    try {
      jsonData.groups.forEach((group) => {
        var stats = []

        group.standings.forEach((record) => {
          stats.push({
            footnotes: new Set(),
            logo: record.logo.lg,
            team_name: record.name,
            games: record.games,
            record: `${record.wins}-${record.losses}-${record.draws}`,
            points: record.points,
            gd: `${record.gf > record.ga ? "+" : ""}${record.gf - record.ga}`,
            gd_sort: record.gf - record.ga,
            w: record.wins,
            d: record.draws,
            l: record.losses,
            gf: record.gf,
            ga: record.ga,
            pp: record.pp,
            team_class: "",
            club: record.club,
            penalties: []
          });
        });

        stats.sort(function (a, b) {
          return (
              b.points - a.points ||
              a.pp - b.pp ||
              b.gd_sort - a.gd_sort ||
              a.games - b.games ||
              b.w - a.w
          );
        });

        processedData.groups.push({
          title: group.name,
          stats: stats,
          nationals: true
        })
      });
    } catch (e) {
      console.error(e);
    }
    return processedData;
  };
  
  const { isLoading, error, data } = useQuery({
    staleTime: Infinity,
    queryKey: ["division", divisionData.id, "nationals"],
    queryFn: () =>
      fetch(
        `${process.env.REACT_APP_BUIHA_API_URL}/division/${divisionData.id}/nationals/`
      )
        .then((res) => res.json())
        .then((json) => {
          return processData(json);
        }),
  });

  if (isLoading) return <Loading />;
  if (error) return "An error has occurred: " + error.message;

  return (
    <>
      <div className="flex flex-col items-start justify-center lg:justify-between mb-3">
        {divisionData.is_cup || divisionData.is_nationals ? (
          <>

            <div className="w-full flex flex-col items-start justify-start">

              {/* Leader and next game component */}
              {/*{data.champions.length > 0 && data.next_game !== null ? null : (*/}
              {(data.champions.championship_name !== undefined || data.champions.nationals_name !== undefined || data.champions.gold_name !== undefined) ? (
                      <DivisionWinner
                          champions={data.champions}
                          nationals={true}
                          title={divisionData.name + " " + divisionData.season}
                      />
                  ) : null}
              {/*)}*/}
              {
                (data.next_game !== null) ? (
                    <DivisionInfo
                        team1={data.next_game.home_team.name}
                        team2={data.next_game.away_team.name}
                        team1img={data.next_game.home_team.logo.lg}
                        team2img={data.next_game.away_team.logo.lg}
                        epocdate={data.next_game.date}
                        date={data.next_game.date_text}
                        time={data.next_game.time_text}
                        location={data.next_game.full_location}
                        title={data.next_game.game_title}
                    />
                ) : null}

              <GameEvent eventName={"Group Stage"} title={true}/>

              <div className={`flex flex-wrap w-full g:mx-8 mt-4`}>
                {(data.groups.length > 1) ?
                    <>
                      {data.groups.map((group) => (
                          <div className="flex flex-col xl:px-2 xl:w-1/2 w-full">
                            <StandingsTable table_data={group} extraClasses={""}/>
                          </div>
                      ))}
                    </>
                    :
                    <>
                      {data.groups.map((group) => (
                          <div className="flex flex-col xl:px-2 w-full">
                            <StandingsTable table_data={group} extraClasses={""}/>
                          </div>
                      ))}
                    </>

                }
              </div>

              {data.playoffs.map((bracket, index) => (
                  <Bracket bracket_data={bracket} title={bracket.title} gold={index === 0}/>
              ))}

            </div>
          </>
        ) : null}
      </div>
    </>
  );
};

export default DivisionTournament;
